<template>
    <div>
        <div ref="advancedCalcFilter" class="advanced-calc-filter">
            <div class="filter-header text-right">
                <span>{{ section1HeadersAndSubHeaders.filterHeader }}</span>
            </div>
            <ul class="filter-inputs">
                <li>
                    <number-input
                        id="CreditCardDebt"
                        v-model="CreditCardDebt"
                        :label="section1InputLabels.labelCreditCardDebt"
                        maxlength="6"
                        inputmode="decimal"
                    />
                </li>
                <li>
                    <number-input
                        id="PersonalLoanDebt"
                        v-model="PersonalLoanDebt"
                        :label="section1InputLabels.labelPersonalLoan"
                        maxlength="6"
                        inputmode="decimal"
                        @input="setPersonalLoanMonthlyPayment"
                    />
                </li>
                <li>
                    <number-input
                        id="MedicalDebt"
                        v-model="MedicalDebt"
                        :label="section1InputLabels.labelMedicalExpenses"
                        maxlength="6"
                        inputmode="decimal"
                    />
                </li>
                <li v-if="section1DefaultValues.isOtherDebtVisible">
                    <number-input
                        id="OtherDebt"
                        v-model="OtherDebt"
                        :label="section1InputLabels.labelOtherDebt"
                        maxlength="6"
                        inputmode="decimal"
                    />
                </li>
                <li class="credit-score-range">
                    <drop-down
                        v-model="CreditScoreValue"
                        :label="section1InputLabels.labelCreditRating"
                        :options="CreditScoreList"
                        @input="changeCreditRatingHandler"
                    />
                    <a href="/redirect/offers?id=calc-fcs" class="font-sm" target="_blank">Get your credit score</a>
                </li>
                <li>
                    <button-group-toggle
                        firstButtonText="Rent" divClass="btn-group" secondButtonText="Own" :labelText="section1InputLabels.labelRentOrOwn"
                        :current-selection="CurrentSelection" @toggleSelectionChanged="toggleSelectionHandler"
                    />
                </li>
                <li>
                    <drop-down
                        v-model="State"
                        :label="section1InputLabels.labelState"
                        :options="StateList"
                        classValue="state-view"
                    />
                </li>
                <li :class="section1DefaultValues.isOtherDebtVisible ? 'update-btn' : 'update-btn other-debt-invisible'"><button class="btn customize" :disabled="!IsDataLoaded" type="submit" @click="fetchDMAData('buttonClicked')">{{ section1InputLabels.updateButtonText }}</button></li>
            </ul>
            <label class="show-hide-advance-options" @click="viewMoreClick()">
                <span class="lt-icons" :class="{ 'lt4-MinusCircle': ShowAdvancedOptions, 'lt4-PlusCircle' : !ShowAdvancedOptions}"></span> {{ !ShowAdvancedOptions ? "Enter your details to see savings" : "Hide details" }}
            </label>
        </div>
        <div v-show="ShowAdvancedOptions" class="advanced-calc-filter inside-status">
            <div class="current-status">
                <ul class="filter-inputs">
                    <li><h4>YOUR CURRENT STATUS:</h4></li>
                    <li>
                        <label>{{ section1InputLabels.labelCurrentTotalDebt }}</label>
                        <span>{{ !checkIsNullOrUndefined(currentTotalDebt()) ? '$' + currencyFilter(currentTotalDebt()) : "N/A" }}</span>
                    </li>
                    <li>
                        <label>{{ section1InputLabels.labelCurrentStatusDueNow }}</label>
                        <span>{{ !checkIsNullOrUndefined(CurrentStatus.dueNow) ? '$' + currencyFilter(CurrentStatus.dueNow) : "N/A" }}</span>
                    </li>
                    <li>
                        <label>{{ section1InputLabels.labelCurrentStatusDebtAmount }}</label>
                        <span>{{ !checkIsNullOrUndefined(CurrentStatus.debtAmount) ? '$' + currencyFilter(CurrentStatus.debtAmount) : "N/A" }}</span>
                    </li>
                    <li>
                        <label>{{ section1InputLabels.labelCurrentStatusInterestRate }}</label>
                        <span>{{ !checkIsNullOrUndefined(CurrentStatus.totalInterest) ? '$' + currencyFilter(CurrentStatus.totalInterest) : "N/A" }}</span>
                    </li>
                    <li>
                        <label>{{ section1InputLabels.labelCurrentStatusMonthlyPayment }}</label>
                        <span>{{ !checkIsNullOrUndefined(CurrentStatus.monthlyPayment) ? '$' + currencyFilter(CurrentStatus.monthlyPayment) : "N/A" }}</span>
                    </li>
                    <li>
                        <label>{{ section1InputLabels.labelCurrentStatusDebtFreeBy }}</label>
                        <span>{{ !checkIsNullOrUndefined(CurrentStatus.timeToDebtFree) ? CurrentStatus.timeToDebtFree : "N/A" }}</span>
                    </li>
                </ul>
            </div>
            <!-- Advanced Options start -->
            <div class="row">
                <div class="col-md-6">
                    <div v-show="ShowAdvancedOptions" class="advanced-options" :class="{ 'all-options': ShowAdvancedOptions, 'less-options' : !ShowAdvancedOptions}">
                        <span class="savings-heading">{{ section1HeadersAndSubHeaders.advancedFiltersHeader }}</span>
                        <ul class="filter-inputs">
                            <li class="filter-header"><span>{{ section1HeadersAndSubHeaders.advancedCreditCardHeader }}</span> <lt-label /></li>
                            <li>
                                <number-input
                                    v-model="CreditCardMinimumPayment"
                                    :label="section1InputLabels.labelMinimumPayment"
                                    symbol="%"
                                    symbol-aligned="right"
                                    precision="3"
                                    inputmode="decimal"
                                    max-value="999"
                                    model-name="CreditCardMinimumPayment"
                                    @inputBlur="setValue"
                                />
                            </li>
                            <li>
                                <number-input
                                    v-model="CreditCardAPRPercentage"
                                    :label="section1InputLabels.labelAPR"
                                    symbol="%"
                                    symbol-aligned="right"
                                    precision="3"
                                    inputmode="decimal"
                                    max-value="999"
                                    model-name="CreditCardAPRPercentage"
                                    @inputBlur="setValue"
                                />
                            </li>
                        </ul>
                    </div>
                    <div v-show="ShowAdvancedOptions" class="advanced-options" :class="{ 'all-options no-top-border': ShowAdvancedOptions, 'less-options' : !ShowAdvancedOptions}">
                        <ul class="filter-inputs">
                            <li class="filter-header"><span>{{ section1HeadersAndSubHeaders.advancedPersonalLoanHeader }}</span> <lt-label /></li>
                            <li>
                                <number-input
                                    v-model="PersonalLoanMonthlyPayment"
                                    :label="section1InputLabels.labelMonthlyPayment"
                                    maxlength="6"
                                    inputmode="decimal"
                                />
                            </li>
                            <li>
                                <number-input
                                    v-model="PersonalLoanAPRPercentage"
                                    :label="section1InputLabels.labelAPR"
                                    symbol="%"
                                    symbol-aligned="right"
                                    precision="3"
                                    inputmode="decimal"
                                    max-value="999"
                                    model-name="PersonalLoanAPRPercentage"
                                    @inputBlur="setValue"
                                />
                            </li>
                            <li class="colspan-2">
                                <number-input
                                    v-model="PersonalLoanRemainingTerm"
                                    :label="section1InputLabels.labelRemainingTerm"
                                    symbol="Mo."
                                    symbol-aligned="right"
                                    maxlength="3"
                                    inputmode="decimal"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <div v-show="ShowAdvancedOptions" class="advanced-options" :class="{ 'all-options': ShowAdvancedOptions, 'less-options' : !ShowAdvancedOptions}">
                        <span class="savings-heading">{{ section1HeadersAndSubHeaders.advancedSavingsHeader }}</span>
                        <ul class="filter-inputs">
                            <li class="filter-header"><span>{{ section1HeadersAndSubHeaders.advancedDebtSettlementHeader }}</span> <lt-label /></li>
                            <li>
                                <number-input
                                    v-model="DebtSettlementRate"
                                    :label="section1InputLabels.labelDebtSettlement"
                                    symbol="%"
                                    symbol-aligned="right"
                                    precision="3"
                                    inputmode="decimal"
                                    max-value="999"
                                    model-name="DebtSettlementRate"
                                    @inputBlur="setValue"
                                />
                            </li>
                            <li>
                                <number-input
                                    v-model="DebtSettlementFees"
                                    :label="section1InputLabels.labelDebtSettlementFees"
                                    symbol="%"
                                    symbol-aligned="right"
                                    precision="3"
                                    inputmode="decimal"
                                    max-value="999"
                                    model-name="DebtSettlementFees"
                                    @inputBlur="setValue"
                                />
                            </li>
                        </ul>
                    </div>
                    <div v-show="ShowAdvancedOptions" class="advanced-options" :class="{ 'all-options no-top-border': ShowAdvancedOptions, 'less-options' : !ShowAdvancedOptions}">
                        <ul class="filter-inputs">
                            <li class="filter-header"><span>{{ section1HeadersAndSubHeaders.advancedHomeEquityHeader }}</span> <lt-label /></li>
                            <li>
                                <number-input
                                    v-model="HomeEquityAPRPercentage"
                                    :label="section1InputLabels.labelAPR"
                                    symbol="%"
                                    symbol-aligned="right"
                                    precision="3"
                                    inputmode="decimal"
                                    max-value="999"
                                    model-name="HomeEquityAPRPercentage"
                                    @inputBlur="setValue"
                                />
                            </li>
                            <li>
                                <number-input
                                    v-model="HomeEquityTerm"
                                    :label="section1InputLabels.labelTerm"
                                    symbol="Mo."
                                    symbol-aligned="right"
                                    maxlength="3"
                                    inputmode="decimal"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <a v-show="ShowAdvancedOptions" class="reset-calc hidden-xs" @click="resetCalculator()"><span class="lt-icons lt4-Refresh"></span> Reset Calculator</a>
            <!-- Advanced Options end-->
            <button v-show="ShowAdvancedOptions" class="btn btn-blue recalculate" type="submit" :disabled="!IsDataLoaded" @click="fetchDMAData('buttonClicked')"> Recalculate</button>
        </div>
        <div ref="dmaSection2" class="dial-container">
            <transition v-if="!IsDataLoaded" name="fade">
                <div class="loader">
                    <img alt="lt-loader" width="61" height="60" src="data:image/png;base64,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" />
                </div>
            </transition>
            <div v-else-if="IsDataLoaded && !IsAPIDataLoaded" class="no-data">Unable to fetch results at this point, please try again after a few minutes.</div>
        </div>
        <div v-show="IsAPIDataLoaded" v-if="(Section2FormattedData.length > 0)" class="debt-management-options">
            <div class="text-center">
                <h3>Your Debt Management Options</h3>
            </div>
            <div v-for="(debtOption, index) in Section2FormattedData" :key="debtOption.debtOptionName" class="tile">
                <div class="tile-block">
                    <div class="text-left">
                        <label class="recommend-label recommended">{{ index == 0? 'RECOMMENDED' : '&nbsp;' }}</label>
                        <lt-label>Whats's this?</lt-label>
                    </div>
                    <p class="icon"><i :class="debtOption.icon"></i></p>
                    <label class="loan-info-label">{{ debtOption.loanInfoLabel }}</label>
                    <h4 class="loan-title">{{ debtOption.debtOptionName }}</h4>
                    <p class="loan-covers-info"><i>Covers <span>{{ debtOption.debtCovered? '$' + currencyFilter(debtOption.debtCovered) : 'N/A' }}</span> of <span>{{ !checkIsNullOrUndefined(currentTotalDebt()) ? '$' + currencyFilter(currentTotalDebt()) : "N/A" }}</span></i><i>*</i></p>
                    <label class="collaterral-label">{{ debtOption.tag ? debtOption.tag : "Debt Option" }}</label>
                    <div class="saving-section">
                        <div class="row text-center">
                            <div :class="[ 'col-xs-6', { 'col-xs-offset-3': debtOption.isCreditCard }, 'column']">
                                <span class="saving-title">Estimated Monthly <br />Payment</span>
                            </div>
                            <div v-if="!debtOption.isCreditCard" class="col-xs-6 column">
                                <span class="saving-title">Time to Being <br />Debt-Free</span>
                            </div>
                        </div>
                        <div class="row text-center">
                            <div :class="[ 'col-xs-6', { 'col-xs-offset-3': debtOption.isCreditCard }, 'column']">
                                <h3 class="saving-amount">{{ debtOption.newMonthlyPayment? '$' + currencyFilter(debtOption.newMonthlyPayment) : 'N/A' }}</h3>
                            </div>
                            <div v-if="!debtOption.isCreditCard" class="col-xs-6 column">
                                <h3 class="saving-amount">{{ debtOption.debtFreeBy }}</h3>
                            </div>
                        </div>
                    </div>
                    <a :href="debtOption.targetURL" target="_blank" class="btn btn-block tile-button">{{ debtOption.buttonText }}</a>
                    <div class="debt-covered text-center" v-html="getDebtOptionsText(debtOption.bifurcation)"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import moment from 'moment';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import ButtonGroupToggle from '~/components/button-group-toggle.vue';
    import DefaultTooltip from '~/constants/tooltip-defaults';
    import CreditScoreList from '~/constants/credit-score-list';
    import States from '~/constants/states';
    import LtLabel from '~/components/lt-label.vue';
    import { GetIpAddress } from '~/services/geo-location';
    import RuleEngineAPIService from '~/services/rule-engine-api';
    import splitterUrlEnv from '~/helpers/splitter-url-env';
    import { trackWidgetUsed } from '~/services/debt-management-advisor-tracking';

    export default {
        props: {
            showAdvancedOptions: {
                default: false,
            },
            creditCardDebtTooltip: {
                default: DefaultTooltip.CreditCardDebt,
            },
            personalLoansTooltip: {
                default: DefaultTooltip.PersonalLoans,
            },
            medicalExpensesTooltip: {
                default: DefaultTooltip.MedicalExpenses,
            },
            otherDebtTooltip: {
                default: DefaultTooltip.OtherDebt,
            },
            debtSettlementOptionTooltip: {
                default: DefaultTooltip.DebtSettlementOption,
            },
            creditCardOptionTooltip: {
                default: DefaultTooltip.CreditCardOption,
            },
            personalLoanOptionTooltip: {
                default: DefaultTooltip.PersonalLoanOption,
            },
            homeEquityOptionTooltip: {
                default: DefaultTooltip.HomeEquityOption,
            },
            debtSettlementSavingTooltip: {
                default: DefaultTooltip.DebtSettlementSaving,
            },
            balanceTransferSavingTooltip: {
                default: DefaultTooltip.BalanceTransferSaving,
            },
            homeEquitySavingTooltip: {
                default: DefaultTooltip.HomeEquitySaving,
            },
            personalLoanSavingTooltip: {
                default: DefaultTooltip.PersonalLoanSaving,
            },
            currentStatus: {
                type: Object,
                default() {
                    return {
                        debtAmount: 0,
                        interestRate: 0,
                        monthlyPayment: 0,
                        timeToDebtFree: 'N/A',
                        totalInterest: 0,
                    };
                },
            },
            hasUpdateButtonClicked: {
                default: false,
            },
            section1HeadersAndSubHeaders: {
                default() {
                    return {
                        filterHeader: 'Enter Your Personal Debts',
                        advancedFiltersHeader: 'Current Debt Details',
                        advancedCreditCardHeader: 'Credit Card',
                        advancedPersonalLoanHeader: 'Personal Loan',
                        advancedSavingsHeader: 'Savings Assumptions',
                        advancedDebtSettlementHeader: 'Debt Settlement',
                        advancedHomeEquityHeader: 'Home Equity',
                    };
                },
            },
            section1InputLabels: {
                default() {
                    return {
                        labelCreditCardDebt: 'Credit Card Debt',
                        labelPersonalLoan: 'Personal Loans',
                        labelMedicalExpenses: 'Medical Expenses',
                        labelOtherDebt: 'Other Debt',
                        labelCreditRating: 'Credit Score',
                        labelState: 'State',
                        labelTerm: 'Term',
                        labelRemainingTerm: 'Remaining Term',
                        labelMinimumPayment: 'Minimum Payment',
                        labelMonthlyPayment: 'Monthly Payment',
                        labelAPR: 'APR',
                        updateButtonText: 'Calculate',
                        labelDebtSettlement: 'Savings',
                        labelDebtSettlementFees: 'Fees',
                        labelCurrentStatusDebtAmount: 'Debt',
                        labelCurrentStatusInterestRate: 'Interest',
                        labelCurrentStatusMonthlyPayment: 'Mo. Payment',
                        labelCurrentStatusDebtFreeBy: 'Debt Free By',
                        labelCurrentStatusDueNow: 'Due Now',
                        labelCurrentTotalDebt: 'Total Debt',
                        step3Text: 'Results updated, see your savings.',
                        section2OptionInfo1: 'Debt Covered',
                        section2OptionInfo2: 'Not Covered',
                        section2OptionInfo3: 'Mo. Payment',
                        dialSeeDetailsButtonText: 'See Details',
                        dialNewPaymentText: 'New Monthly Payment: ',
                        dialSeeOffersButtonText: 'See your offers',
                        labelRentOrOwn: 'Rent Or Own',
                    };
                },
            },
            section1DefaultValues: {
                default() {
                    return {
                        creditScore: 'Good',
                        state: 'NC',
                        creditCardDebt: 10000,
                        personalLoanDebt: 5000,
                        medicalDebt: 0,
                        otherDebt: 0,
                        debtSettlementRate: 30.000,
                        debtSettlementFees: 15.000,
                        creditCardMinimumPaymentPercentage: 4.000,
                        personalLoanMinimumPaymentPercentage: 3.000,
                        creditcardAPRPercentage: 19.990,
                        personalLoanAPRPercentage: 9.990,
                        personalLoanRemainingTerm: 36,
                        homeEquityAPRPercentage: 4.990,
                        homeEquityTerm: 120,
                        rentOrOwnSelection: 'Own',
                        isOtherDebtVisible: true,
                    };
                },
            },
        },
        data() {
            return {
                CreditScoreList: CreditScoreList.debtManagementAdvisor,
                StateList: States.StateListShortNames,
                State: this.section1DefaultValues.state,
                CreditScoreValue: this.section1DefaultValues.creditScore,
                ShowAdvancedOptions: this.showAdvancedOptions,
                CreditCardDebtTooltip: parseInt(this.hideTooltip, 10) ? '' : this.creditCardDebtTooltip,
                PersonalLoansTooltip: parseInt(this.hideTooltip, 10) ? '' : this.personalLoansTooltip,
                MedicalExpensesTooltip: parseInt(this.hideTooltip, 10) ? '' : this.medicalExpensesTooltip,
                OtherDebtTooltip: parseInt(this.hideTooltip, 10) ? '' : this.otherDebtTooltip,
                DebtSettlementOptionTooltip: parseInt(this.hideTooltip, 10) ? '' : this.debtSettlementOptionTooltip,
                CreditCardOptionTooltip: parseInt(this.hideTooltip, 10) ? '' : this.creditCardOptionTooltip,
                PersonalLoanOptionTooltip: parseInt(this.hideTooltip, 10) ? '' : this.personalLoanOptionTooltip,
                HomeEquityOptionTooltip: parseInt(this.hideTooltip, 10) ? '' : this.homeEquityOptionTooltip,
                DebtSettlementSavingTooltip: parseInt(this.hideTooltip, 10) ? '' : this.debtSettlementSavingTooltip,
                BalanceTransferSavingTooltip: parseInt(this.hideTooltip, 10) ? '' : this.balanceTransferSavingTooltip,
                HomeEquitySavingTooltip: parseInt(this.hideTooltip, 10) ? '' : this.homeEquitySavingTooltip,
                PersonalLoanSavingTooltip: parseInt(this.hideTooltip, 10) ? '' : this.personalLoanSavingTooltip,
                CreditCardAPRPercentage: this.section1DefaultValues.creditcardAPRPercentage,
                PersonalLoanAPRPercentage: this.section1DefaultValues.personalLoanAPRPercentage,
                PersonalLoanRemainingTerm: this.section1DefaultValues.personalLoanRemainingTerm,
                HomeEquityAPRPercentage: this.section1DefaultValues.homeEquityAPRPercentage,
                HomeEquityTerm: this.section1DefaultValues.homeEquityTerm,
                CreditCardDebt: this.section1DefaultValues.creditCardDebt,
                PersonalLoanDebt: this.section1DefaultValues.personalLoanDebt,
                MedicalDebt: this.section1DefaultValues.medicalDebt,
                OtherDebt: this.section1DefaultValues.otherDebt,
                DebtSettlementRate: this.section1DefaultValues.debtSettlementRate,
                DebtSettlementFees: this.section1DefaultValues.debtSettlementFees,
                CreditCardMinimumPayment: this.section1DefaultValues.creditCardMinimumPaymentPercentage,
                PersonalLoanMonthlyPayment: this.section1DefaultValues.personalLoanDebt * this.section1DefaultValues.personalLoanMinimumPaymentPercentage / 100,
                CurrentSelection: this.section1DefaultValues.rentOrOwnSelection,
                CurrentStatus: this.currentStatus,
                DMACalculationData: null,
                Section2FormattedData: [],
                ShowLeftBlock: true,
                IsDataLoaded: true,
                IsAPIDataLoaded: true,
                leftBlockClass: '',
                HasUpdateButtonClicked: this.hasUpdateButtonClicked,
            };
        },
        mounted() {
            this.getLocationByIPAddress();
            this.fetchDMAData('');
        },
        methods: {
            getDebtOptionsText(debtOptionsBifurcation) {
                const line = [];
                for (let i = 0; i < debtOptionsBifurcation.length; ++i) {
                    if (debtOptionsBifurcation[i] && debtOptionsBifurcation[i].value > 0) {
                        line.push(`<span>${debtOptionsBifurcation[i].name},</span>`);
                    }
                }
                line[line.length - 1] = line[line.length - 1].replace(/,/g, '');
                return `<i>*</i>Covered: ${line.join(' ')}`;
            },
            setValue(input) {
                this[input.model] = input.value;
            },
            viewMoreClick() {
                this.ShowAdvancedOptions = !this.ShowAdvancedOptions;
            },
            currencyFilter(figure, precisionValue) {
                return precisionValue ? Accounting.formatNumber(figure, { precision: precisionValue }) : Accounting.formatNumber(figure);
            },
            addMonthsToDate(date, monthsToBeAdded) {
                return moment(date).add(monthsToBeAdded, 'months').format('MMM YYYY');
            },
            setPersonalLoanMonthlyPayment() {
                this.PersonalLoanMonthlyPayment = this.PersonalLoanDebt * this.section1DefaultValues.personalLoanMinimumPaymentPercentage / 100;
            },
            getLocationByIPAddress() {
                GetIpAddress().then((data) => {
                    if (data && data.state) {
                        this.State = data.state;
                    } else {
                        this.State = this.state;
                    }
                }, (error) => {
                    if (error && error.state) {
                        this.State = error.state;
                    } else {
                        this.State = this.state;
                    }
                });
            },
            resetCalculator() {
                this.CreditCardDebt = this.currencyFilter(this.section1DefaultValues.creditCardDebt);
                this.PersonalLoanDebt = this.currencyFilter(this.section1DefaultValues.personalLoanDebt);
                this.MedicalDebt = this.currencyFilter(this.section1DefaultValues.medicalDebt);
                this.OtherDebt = this.currencyFilter(this.section1DefaultValues.otherDebt);
                this.DebtSettlementRate = this.currencyFilter(this.section1DefaultValues.debtSettlementRate, 3);
                this.DebtSettlementFees = this.currencyFilter(this.section1DefaultValues.debtSettlementFees, 3);
                this.CreditCardAPRPercentage = this.currencyFilter(this.section1DefaultValues.creditcardAPRPercentage, 3);
                this.PersonalLoanAPRPercentage = this.currencyFilter(this.section1DefaultValues.personalLoanAPRPercentage, 3);
                this.PersonalLoanRemainingTerm = this.section1DefaultValues.personalLoanRemainingTerm;
                this.HomeEquityAPRPercentage = this.currencyFilter(this.section1DefaultValues.homeEquityAPRPercentage, 3);
                this.HomeEquityTerm = this.section1DefaultValues.homeEquityTerm;
                this.CreditCardMinimumPayment = this.currencyFilter(this.section1DefaultValues.creditCardMinimumPaymentPercentage, 3);
                this.PersonalLoanMonthlyPayment = this.currencyFilter(this.section1DefaultValues.personalLoanDebt * this.section1DefaultValues.personalLoanMinimumPaymentPercentage / 100);
                this.CreditScoreValue = this.section1DefaultValues.creditScore;
                this.CurrentSelection = this.section1DefaultValues.rentOrOwnSelection;
                this.getLocationByIPAddress();
            },
            toggleSelectionHandler(selection) {
                this.CurrentSelection = selection;
            },
            fetchDMAData(value) {
                if (value) {
                    this.IsDataLoaded = false;
                    this.IsAPIDataLoaded = false;
                    this.HasUpdateButtonClicked = true;
                    this.$emit('dataLoaded', this.IsDataLoaded);
                }
                const creditScore = this.CreditScoreList.filter(item => item.value === this.CreditScoreValue);
                const DMARequest = {
                    creditCardDebtAmount: Math.round(Accounting.unformat(this.CreditCardDebt)),
                    creditCardAPR: parseFloat(this.CreditCardAPRPercentage).toFixed(3),
                    creditCardMonthlyPaymentRate: parseFloat(this.CreditCardMinimumPayment).toFixed(3),
                    personalLoanDebtAmount: Math.round(Accounting.unformat(this.PersonalLoanDebt)),
                    personalLoanAPR: parseFloat(this.PersonalLoanAPRPercentage).toFixed(3),
                    personalLoanMonthlyPayment: Math.round(this.PersonalLoanMonthlyPayment),
                    personalLoanRemainingTermInMonths: Math.round(this.PersonalLoanRemainingTerm),
                    medicalDebtAmount: Math.round(this.MedicalDebt),
                    otherDebtAmount: Math.round(this.OtherDebt),
                    debtSettlementSavings: parseFloat(this.DebtSettlementRate).toFixed(3),
                    debtSettlementFees: parseFloat(this.DebtSettlementFees).toFixed(3),
                    homeEquityApr: parseFloat(this.HomeEquityAPRPercentage).toFixed(3),
                    homeEquityTermInMonths: Math.round(this.HomeEquityTerm),
                    creditBand: creditScore[0].value,
                    rentOrOwn: this.CurrentSelection,
                    stateCode: this.State,
                };
                RuleEngineAPIService.getDMACalculations('/debtanalyzer?', DMARequest, (response) => {
                    this.DMACalculationData = response;
                    let queryString = window.location.search.substring(1);
                    queryString = queryString ? `&${queryString}` : '';
                    if (this.checkIsNullOrUndefined(this.DMACalculationData.result)) {
                        if (!value) this.IsAPIDataLoaded = true;
                        this.IsDataLoaded = true;
                        this.$emit('dataLoaded', this.IsAPIDataLoaded);
                    } else {
                        this.IsDataLoaded = true;
                        this.IsAPIDataLoaded = true;
                        this.$emit('dataLoaded', this.IsDataLoaded);
                        if (response && response.result) {
                            if (response.result.currentDebtStatus) {
                                const { currentDebtStatus } = response.result;
                                this.CurrentStatus.debtAmount = currentDebtStatus.debtAmount;
                                this.CurrentStatus.interestRate = currentDebtStatus.interestRate;
                                this.CurrentStatus.monthlyPayment = currentDebtStatus.totalMonthlyPayment;
                                this.CurrentStatus.timeToDebtFree = !currentDebtStatus.timeToDebtFreeInMonths || currentDebtStatus.timeToDebtFreeInMonths <= 0 ? 'N/A' : this.addMonthsToDate(new Date(), currentDebtStatus.timeToDebtFreeInMonths);
                                this.CurrentStatus.dueNow = currentDebtStatus.dueNow;
                                this.CurrentStatus.totalInterest = currentDebtStatus.totalInterest;
                            }
                            this.Section2FormattedData = [];
                            this.ShowLeftBlock = false;
                            setTimeout(() => {
                                this.ShowLeftBlock = true;
                                if (value) this.$refs.dmaSection2.scrollIntoView(true);
                            }, 50);

                            if (response.result.debtSavingSettlement) {
                                this.Section2FormattedData.push(
                                    {
                                        debtOptionName: 'Debt Settlement',
                                        icon: 'lt4-Debt',
                                        loanInfoLabel: 'Reduce what you owe with',
                                        debtCovered: response.result.debtSavingSettlement.debtCovered.total,
                                        debtNotCovered: response.result.debtSavingSettlement.debtNotCovered.total,
                                        newMonthlyPayment: response.result.debtSavingSettlement.monthlyPayment,
                                        newInterest: response.result.debtSavingSettlement.totalInterest,
                                        debtFreeBy: response.result.debtSavingSettlement.timeToDebtFreeInMonths ? `${response.result.debtSavingSettlement.timeToDebtFreeInMonths} mos.` : 'N/A',
                                        totalSaving: response.result.debtSavingSettlement.totalSaving,
                                        tag: response.result.debtSavingSettlement.tag,
                                        rank: response.result.debtSavingSettlement.rank,
                                        tooltip: this.DebtSettlementSavingTooltip,
                                        targetURL: `${splitterUrlEnv.getSplitterURL()}/api/split?id=dr-dma-dr${queryString}`,
                                        buttonText: 'Get Debt Settlement Offers',
                                        learnMoreLinkText: 'Learn more about debt settlement',
                                        bifurcation: [
                                            { name: 'Credit Cards', value: response.result.debtSavingSettlement.debtCovered.creditCard },
                                            { name: 'Personal Loans', value: response.result.debtSavingSettlement.debtCovered.personalLoan },
                                            { name: 'Medical Expenses', value: response.result.debtSavingSettlement.debtCovered.medical },
                                            { name: 'Other Debt', value: response.result.debtSavingSettlement.debtCovered.other },
                                        ],
                                    },
                                );
                            }
                            if (response.result.balanceTransferCard) {
                                this.Section2FormattedData.push(
                                    {
                                        debtOptionName: 'Balance Transfer Card',
                                        icon: 'lt4-CreditCards',
                                        loanInfoLabel: 'Shift balances to a',
                                        debtCovered: response.result.balanceTransferCard.debtCovered.total,
                                        debtNotCovered: response.result.balanceTransferCard.debtNotCovered.total,
                                        newMonthlyPayment: response.result.balanceTransferCard.monthlyPayment,
                                        newInterest: response.result.balanceTransferCard.totalInterest,
                                        debtFreeBy: '',
                                        totalSaving: response.result.balanceTransferCard.totalSaving,
                                        tag: response.result.balanceTransferCard.tag,
                                        rank: response.result.balanceTransferCard.rank,
                                        tooltip: this.BalanceTransferSavingTooltip,
                                        targetURL: `${splitterUrlEnv.getSplitterURL()}/api/split?id=dr-dma-cc${queryString}`,
                                        buttonText: 'Compare Balance Transfer Cards',
                                        learnMoreLinkText: 'Learn more about balance transfer cards',
                                        bifurcation: [
                                            { name: 'Credit Cards', value: response.result.balanceTransferCard.debtCovered.creditCard },
                                            { name: 'Personal Loans', value: response.result.balanceTransferCard.debtCovered.personalLoan },
                                            { name: 'Medical Expenses', value: response.result.balanceTransferCard.debtCovered.medical },
                                            { name: 'Other Debt', value: response.result.balanceTransferCard.debtCovered.other },
                                        ],
                                        isCreditCard: true,
                                    },
                                );
                            }
                            if (response.result.homeEquityLoan) {
                                this.Section2FormattedData.push(
                                    {
                                        debtOptionName: 'Home Equity Loan',
                                        icon: 'lt4-HomeEquity',
                                        loanInfoLabel: 'Leverage your equity with a',
                                        debtCovered: response.result.homeEquityLoan.debtCovered.total,
                                        debtNotCovered: response.result.homeEquityLoan.debtNotCovered.total,
                                        newMonthlyPayment: response.result.homeEquityLoan.monthlyPayment,
                                        newInterest: response.result.homeEquityLoan.totalInterest,
                                        debtFreeBy: response.result.homeEquityLoan.timeToDebtFreeInMonths ? `${response.result.homeEquityLoan.timeToDebtFreeInMonths} mos.` : 'N/A',
                                        totalSaving: response.result.homeEquityLoan.totalSaving,
                                        tag: response.result.homeEquityLoan.tag,
                                        rank: response.result.homeEquityLoan.rank,
                                        tooltip: this.HomeEquitySavingTooltip,
                                        targetURL: `${splitterUrlEnv.getSplitterURL()}/api/split?id=dr-dma-he${queryString}`,
                                        buttonText: 'Get Home Equity Offers',
                                        learnMoreLinkText: 'Learn more about home equity loans',
                                        bifurcation: [
                                            { name: 'Credit Cards', value: response.result.homeEquityLoan.debtCovered.creditCard },
                                            { name: 'Personal Loans', value: response.result.homeEquityLoan.debtCovered.personalLoan },
                                            { name: 'Medical Expenses', value: response.result.homeEquityLoan.debtCovered.medical },
                                            { name: 'Other Debt', value: response.result.homeEquityLoan.debtCovered.other },
                                        ],
                                    },
                                );
                            }
                            if (response.result.personalLoan) {
                                this.Section2FormattedData.push(
                                    {
                                        debtOptionName: 'Personal Loan',
                                        icon: 'lt4-PersonalLoans',
                                        loanInfoLabel: 'Consolidate into a',
                                        debtCovered: response.result.personalLoan.debtCovered.total,
                                        debtNotCovered: response.result.personalLoan.debtNotCovered.total,
                                        newMonthlyPayment: response.result.personalLoan.monthlyPayment,
                                        newInterest: response.result.personalLoan.totalInterest,
                                        debtFreeBy: response.result.personalLoan.timeToDebtFreeInMonths ? `${response.result.personalLoan.timeToDebtFreeInMonths} mos.` : 'N/A',
                                        totalSaving: response.result.personalLoan.totalSaving,
                                        tag: response.result.personalLoan.tag,
                                        rank: response.result.personalLoan.rank,
                                        tooltip: this.PersonalLoanSavingTooltip,
                                        targetURL: `${splitterUrlEnv.getSplitterURL()}/api/split?id=dr-dma-pl${queryString}`,
                                        buttonText: 'Get Personal Loan Offers',
                                        learnMoreLinkText: 'Learn more about personal loans',
                                        bifurcation: [
                                            { name: 'Credit Cards', value: response.result.personalLoan.debtCovered.creditCard },
                                            { name: 'Personal Loans', value: response.result.personalLoan.debtCovered.personalLoan },
                                            { name: 'Medical Expenses', value: response.result.personalLoan.debtCovered.medical },
                                            { name: 'Other Debt', value: response.result.personalLoan.debtCovered.other },
                                        ],
                                    },
                                );
                            }
                        }
                        this.Section2FormattedData = this.Section2FormattedData.sort((a, b) => a.rank - b.rank);

                        this.$emit('receiveApiData', this.DMACalculationData);
                        if (value) {
                            const trackRequest = {
                                creditCardDebtAmount: this.currencyFilter(this.CreditCardDebt),
                                personalLoanDebtAmount: this.currencyFilter(this.PersonalLoanDebt),
                                medicalDebtAmount: this.currencyFilter(this.MedicalDebt),
                                otherDebtAmount: this.currencyFilter(this.OtherDebt),
                                totalDebtAmount: this.currencyFilter(this.CurrentStatus.debtAmount),
                                creditBand: creditScore[0].value,
                                rentOrOwn: this.CurrentSelection,
                                stateCode: this.State,
                                debtSettlementSavings: parseFloat(this.DebtSettlementRate).toFixed(3),
                                debtSettlementFees: parseFloat(this.DebtSettlementFees).toFixed(3),
                                creditCardAPR: parseFloat(this.CreditCardAPRPercentage).toFixed(3),
                                creditCardMinimumPayment: parseFloat(this.CreditCardMinimumPayment).toFixed(3),
                                personalLoanAPR: parseFloat(this.PersonalLoanAPRPercentage).toFixed(3),
                                personalLoanMonthlyPayment: Math.round(this.PersonalLoanMonthlyPayment),
                                personalLoanRemainingTermInMonths: Math.round(this.PersonalLoanRemainingTerm),
                                homeEquityApr: parseFloat(this.HomeEquityAPRPercentage).toFixed(3),
                                homeEquityTermInMonths: Math.round(this.HomeEquityTerm),
                            };
                            trackWidgetUsed(trackRequest);
                        }
                    }
                });
            },
            changeCreditRatingHandler(newValue) {
                const creditRatingText = this.CreditScoreList.filter(item => item.value === newValue);
                if (creditRatingText[0].value.toLowerCase() === 'good' || creditRatingText[0].value.toLowerCase() === 'excellent') {
                    this.HomeEquityAPRPercentage = 4.99;
                } else {
                    this.HomeEquityAPRPercentage = 6.99;
                }
            },
            checkIsNullOrUndefined(valueToCheck) {
                return valueToCheck === null || valueToCheck === undefined;
            },
            currentTotalDebt() {
                return parseInt(this.CurrentStatus.dueNow, 10) + parseInt(this.CurrentStatus.debtAmount, 10);
            },
        },
        components: {
            NumberInput,
            DropDown,
            ButtonGroupToggle,
            LtLabel,
        },
    };
</script>
